import React, { Component } from 'react';
import './account.scss';
import './accountContainer.scss';

import FlipCard, {FlipCardFront, FlipCardBack} from '../../../components/FlipCard/FlipCard';
import Withdrawal from './Withdrawal';
import Deposit from './Deposit';
import chevDown from '../../../assets/images/chev-down-royal.svg';
import chevUp from '../../../assets/images/chev-up.svg';
import {formatCurrency} from '../../../utils/helpers';
import withFeatureFlags from '../../FeatureFlags/withFeatureFlags';
import Button from '../../../components/Form/Button/Button';
import AccountActivity from '../AccountActivity/AccountActivity';
import '../../SharedComponents/button-styles.scss'
import AccountDetails from "./AccountDetails";
import { useUnifiedAnalytics } from '../../../contexts/AnalyticsWrapper';
import RateChangeNotification from '../RateChangeNotification/RateChangeNotification';

/** @import { WithFeatureFlagsProps } from '../../FeatureFlags/FeatureFlagsTypes' */
/** @import { AccountOFSProps,AccountOFSState } from './AccountOFSTypes' */

/**
 * @typedef {Object} WithAnalyticsProps
 * @property {import('../../../contexts/AnalyticsWrapperTypes').UnifiedAnalytics} analytics
 */

/** @extends {Component<AccountOFSProps & WithFeatureFlagsProps & WithAnalyticsProps, AccountOFSState>} */
class AccountOFS extends Component {
    /** @type {AccountOFSState} */
    state = {
        flipped: false,
        action: null,
        accountActivitiesEnabled: false,
        showPopupInline: null,
        isRateNotificationVisible: false,
    };
    setRateChangeNotification = () => {
        const { account, analytics } = this.props;

        this.setState({
            isRateNotificationVisible: !this.state.isRateNotificationVisible
        });

        if(analytics){
            analytics.trackAnalyticsClickEvent(
                'rate change',
                window.location.href,
                'rate notification',
                account?.product.name,
                '',
                {},
                this.state.isRateNotificationVisible ? 'hide' : 'reveal',
                'dashboard|click|show-rate-change',
                'rate change notification'
            );
        }
    };

    onSelectActivity = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) => {
        event.preventDefault();

        const {account, onSelectActivity} = this.props;

        this.setState(({accountActivitiesEnabled}) => ({
            accountActivitiesEnabled: !accountActivitiesEnabled
        }), () => {
            if (typeof onSelectActivity === 'function') onSelectActivity(account);
        });
    };

    startAction(/** @type {string} */ action) {

        this.setState({
            isRateNotificationVisible: !this.state.isRateNotificationVisible ? this.state.isRateNotificationVisible : !this.state.isRateNotificationVisible
        });

        this.setState({action}, () => {
            setTimeout(() => {
                this.setState({flipped: true}, () => {
                    this.onActionStart();
                });
            }, 1);
        });
    };

    startWithdrawal = () => {
        this.startAction('withdraw');
    };

    startTransfer = () => {
        this.startAction('transfer');
    };

    startDeposit = () => {
        this.startAction('deposit');
    };

    unflipCard = () => {
        const {account, onActionComplete} = this.props;
        this.setState({flipped: false}, () => {
            if (typeof onActionComplete === 'function') onActionComplete(account);
        });
    };

    onActionStart = () => {
        const {account, onActionStart , analytics} = this.props;

        if(analytics){
            analytics.trackAnalyticsClickTransactionEvent(
                'start',
                account.product.code,
                this.state.action || '',
                'fixed rate saver',
                `dashboard|click|${account.product.code}-move-money`,
                'dashboard'
            );
        }
        if (typeof onActionStart === 'function') onActionStart(account);
    };

    onAfterFlip = (/** @type {boolean} */ flipped) => {
        if (!flipped) {
            this.setState({action: null});
        }
    };

    accountIsClosed = (/** @type {string} */ status) => {
        return status === "ClosureRequested" || status === "Closed";
    };

    renderClosureMessage = (/** @type {string} */ status) => {
        if (status === "ClosureRequested")
            return 'CLOSURE IN PROGRESS';

        if (status === "Closed")
            return "CLOSED";

        return '';
    };

    renderAccountLink(/** @type {string} */ className) {
        const {activityIsShowing} = this.props;
        let activeClass = activityIsShowing ? 'account__link--active' : '';
        return (
            <a href="#" className={["account__link", activeClass, className].join(' ')} onClick={this.onSelectActivity}>
                <span>Account activity</span>
                {this.state.accountActivitiesEnabled && <img className="account__link-icon" src={chevUp}/>}
                {!this.state.accountActivitiesEnabled && <img className="account__link-icon" src={chevDown}/>}
            </a>
        );
    };

    renderInfoSection() {
        const {account, featureEnabled} = this.props;
        return (
            <div className="account__actions">
                {this.accountIsClosed(account.accountStatus)
                    ? <p className="account__closed-message">{this.renderClosureMessage(account.accountStatus)}</p>
                    : <>
                        <Button size='med'
                                label="Move money"
                                disabled={account.balance === 0 || !featureEnabled('CoreWithdrawalFunctionality')}
                                onClick={this.startWithdrawal}/>
                    </>
                }
            </div>
        );
    };

    renderClosureMessageSection() {
        const {account} = this.props;
        return (
            <div className="account__actions">
                <p className="account__closed-message">{this.renderClosureMessage(account.accountStatus)}</p>
            </div>
        );
    };

    renderAccountFront() {
        const { account, featureEnabled, customer } = this.props;
        const rateChangeslist = account.product.rateChanges;

        return (
            <div className="accountcontainer">
                <div
                    className={this.accountIsClosed(account.accountStatus) ? "account__front account__front--closed" : "account__front"}>
                    <AccountDetails
                        showPopup={this.props.showPopup}
                        account={account}
                        customer={customer}
                        enableBlendedRatePopup/>
                    {/*<div className="account__divider"/>*/}
                    <div
                        className="account__section-right">
                        <div className="account__balance">
                            <span className="account__balance-key">Balance</span>
                            <span className="account__balance-value"
                                  data-accountbalance-number={account.accountNumber}>{formatCurrency(account.balance)}</span>
                        </div>
                        {this.renderAccountLink('account__link--desktop')}
                    </div>
                    {/*<div className="account__divider"/>*/}
                    {this.renderInfoSection()}
                    {this.renderAccountLink('account__link--mobile')}
                </div>
                <div className={this.accountIsClosed(account.accountStatus) ? "accountcontainer__infocontainerhide" : (this.state.flipped ? "accountcontainer__infocontainerhide" : "accountcontainer__front accountcontainer__front--closed")}>

                    {featureEnabled('EnableInterimRateDecrease') ? (rateChangeslist != null && rateChangeslist.length > 0 &&
                        (<div className="accountcontainer__section-left"><RateChangeNotification
                            isRateNotificationVisible={this.state.isRateNotificationVisible}
                            flipped={this.state.flipped} setRateChangeNotification={this.setRateChangeNotification}
                            rateChangeList={rateChangeslist}>
                        </RateChangeNotification></div>)) : <></>}
                </div>
            </div>
        );
    };

    renderWithdrawal() {
        const {account, toAccount, customer} = this.props;
        return (
            <Withdrawal
                account={account}
                toAccount={toAccount}
                customer={customer}
                onCancel={this.unflipCard}
                onDone={this.unflipCard}
                noticePeriod={account.notice ? {
                    unit: account.notice.noticePeriodUnit,
                    length: account.notice.noticePeriod
                } : null}
            />
        );
    };

    renderDeposit() {
        const {account, toAccount} = this.props;
        return (
            <Deposit account={account} toAccount={toAccount} onCancel={this.unflipCard} onDone={this.unflipCard}/>
        );
    };

    renderAccountBackWithdrawal() {
        const {action} = this.state;
        if (action === 'deposit') return this.renderDeposit();
        if (action) return this.renderWithdrawal();
        return null;
    };

    getClassNames() {
        const {hide, disable} = this.props;
        return ['account', hide ? 'account--hidden' : '', disable ? 'account--disabled' : ''].join(' ');
    };

    render() {
        const {flipped} = this.state;
        const {account, accountWithActionInProgress} = this.props;

        return (
            <>
                <div className={this.getClassNames()}>
                    <FlipCard flipped={flipped} onAfterFlip={this.onAfterFlip}>
                        <FlipCardFront>{this.renderAccountFront()}</FlipCardFront>
                        <FlipCardBack>{this.renderAccountBackWithdrawal()}</FlipCardBack>
                    </FlipCard>
                </div>
                {this.state.accountActivitiesEnabled &&
                    <AccountActivity activityRef={this.props.activityRef} account={account}
                                     disable={Boolean(accountWithActionInProgress)}/>}
            </>
        );
    };
}

/**
 * Higher-order component that injects analytics
 * @param {React.ComponentType<any>} Component - Component that needs analytics
 * @returns {React.ComponentType<any>} - Wrapped component with analytics injected
 */
const WithAnalytics = (Component) => {
    /**
     * @param {Object} props - Component props without analytics
     * @returns {JSX.Element}
     */
    return function WrappedComponent(props) {
        const analytics = useUnifiedAnalytics();
        return <Component {...props} analytics={analytics} />;
    }
};

export default WithAnalytics(withFeatureFlags(AccountOFS));
